import React, { useCallback, useMemo } from 'react';
import { Button, Modal } from 'antd';
import { useSelector } from 'react-redux';
import { AvailableModals, closeModal } from './modalSlice';
import { ReduxState, useAppDispatch } from '../../store';
import { styled } from 'styled-components';
import { Link } from 'react-router';
import { useStableParams } from '../../routes/useStableParams';

const TableWrapper = styled.div`
  height: 70vh;
`;

const modalId = AvailableModals.ENTITY_LIST_CONTENTS;

const EntityListContentsModal: React.FC = () => {
  const { projectShortName } = useStableParams();
  const dispatch = useAppDispatch();
  const entityList = useSelector((state: ReduxState) => state.modal.modalData[modalId]?.entityList);

  const handleClose = useCallback(() => dispatch(closeModal()), [dispatch]);

  const footer = useMemo(
    () => (
      <>
        {projectShortName && (
          <Button onClick={handleClose}>
            <Link
              to={`/${projectShortName}/project-administration/entitylists/${entityList?.entityListId}`}
            >
              Open in administration
            </Link>
          </Button>
        )}
        <Button onClick={handleClose}>Close</Button>
      </>
    ),
    [projectShortName, entityList?.entityListId, handleClose],
  );

  if (entityList) {
    return (
      <Modal
        title={`Entity list - ${entityList.name ?? 'undefined'}`}
        centered
        open={true}
        width="80%"
        onCancel={handleClose}
        footer={footer}
      >
        <TableWrapper>TBD</TableWrapper>
      </Modal>
    );
  }
};

export default EntityListContentsModal;
